import type { LibraryImage } from "@/types/content";

export function useImagesFromLibrary() {
  const query = useQuery({
    queryKey: ["image-library"],
    queryFn: async () => {
      const { data } = await useGetRequest<LibraryImage[]>("/content/library-images");
      return data;
    },
    staleTime: 3 * MINUTE,
  });

  return query;
}
